var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophyFill = function SvgTrophyFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 16.445V18.3h4.5v1.8H7.1v-1.8h4.5v-1.855A7.2 7.2 0 0 1 5.3 9.3V3.9h14.4v5.4a7.2 7.2 0 0 1-6.3 7.145M2.6 5.7h1.8v3.6H2.6zm18 0h1.8v3.6h-1.8z"
  })));
};
export default SvgTrophyFill;